'use strict';

const Reflux = require('@muzzylane/reflux');
const reject = require('lodash/reject');

const OrganizationActions = require('../actions/OrganizationActions');
const SignInActions = require('../actions/sign_in_actions');
const ServerRequest = require('../actions/request');
const SignInStore = require('./SignInStore');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

let initialized = false; // unused
let action = {};
let members = {};

const OrganizationMemberStore = Reflux.createStore({
    listenables: [OrganizationActions, SignInActions],
    init: function() {
        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        initialized = false;
        members = {};
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState){
        // if(signInStoreState.initializedLocal){}
        return;
    },

    getState: function() {
        return {
            initialized: initialized,
            action: action,
            members: members
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null; //do not reset channel error
    },

    onError: function(actionID, err) {
        action = { id: actionID };
        if (err.status) {
            switch (err.status) {
                case 404:
                    action.error = new ForgeError({ message: ErrorConsts.MISSING_SECRET, stack: err.responseText || null });
                    break;
                case 400:
                    action.error = new ForgeError({ message: err.responseText || ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetMembersCompleted: function(actionID, orgId, res) {
        // console.log("onGetMembersCompleted: ", actionID, orgId, res);
        members[orgId] = res;
        action = {id: actionID};
        this.emitStatus();
    },

    onGetMembersFailed: function(actionID, orgId, err) {
        console.warn("onGetMembersFailed: ", actionID, orgId, err);
        this.onError(actionID, err);
    },

    onSetOrganizationPermissionCompleted: function(actionID, orgId, newUser) {
        // console.log("onSetOrganizationPermissionCompleted: ", actionID, orgId, newUser);
        let replaced = false;
        members[orgId] = members[orgId].map((member) => {
            if (member.id === newUser.id) { // update permission case
                replaced = true;
                return newUser;
            }

            return member;
        });

        if (!replaced) {
            members[orgId].push(newUser);
        }

        action = {id: actionID};
        this.emitStatus();
    },

    onSetOrganizationPermissionFailed: function(actionID, orgId, err) {
        console.warn("onSetOrganizationPermissionFailed: ", actionID, orgId, err);
        this.onError(actionID, err);
    },

    onRemoveOrganizationMemberCompleted: function(actionID, orgId, userId, res) {
        // console.log("onSetOrganizationPermissionCompleted: ", actionID, orgId, userId, res);
        members[orgId] = reject(members[orgId], {id: userId});
        action = {id: actionID};
        this.emitStatus();
    },

    onRemoveOrganizationMemberFailed: function(actionID, orgId, userId, err) {
        console.warn("onSetOrganizationPermissionFailed: ", actionID, orgId, userId, err);
        this.onError(actionID, err);
    },
});

module.exports = OrganizationMemberStore;
